import { isEmpty } from 'lodash';

export type Cpt = {
  code: string;
  modifier?: string;
  description: string;
};

export const formatCptCode = (cpt: Cpt) => {
  return [cpt.code, cpt.modifier].filter(x => !isEmpty(x)).join('.');
};
